import { useEffect } from 'react';

const editableSelector = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="combobox"], [role="spinbutton"]';
const isEditable = target => Boolean(target?.isContentEditable || target?.closest?.(editableSelector));

export default function useTokenRotationShortcuts(tokenId, rotateTokenBy, lockRotation, step) {
  useEffect(() => {
    if (!tokenId) return undefined;
    const handleKeyDown = event => {
      if (!event || typeof event.key !== 'string' || event.defaultPrevented || event.isComposing || event.ctrlKey || event.metaKey || event.altKey) return;
      // Dialogs render through portals, but their keystrokes still reach window.
      // Check the focused element too, for events retargeted to document/window.
      if (isEditable(document.activeElement) || isEditable(event.target) || event.composedPath?.().some(isEditable)) return;
      const key = event.key, lowerKey = key.toLowerCase();
      if (['ArrowLeft', '[', '{'].includes(key) || ['a', 'q'].includes(lowerKey)) {
        event.preventDefault(); rotateTokenBy(tokenId, -step);
      } else if (['ArrowRight', ']', '}'].includes(key) || ['d', 'e'].includes(lowerKey)) {
        event.preventDefault(); rotateTokenBy(tokenId, step);
      } else if (['Enter', ' ', 'Spacebar', 'Escape'].includes(key)) {
        event.preventDefault(); lockRotation(tokenId);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [tokenId, rotateTokenBy, lockRotation, step]);
}
